module.exports = "<div>\n    <div class=\"auth-left-colors\"></div>\n    <div class=\"auth-right-colors\"></div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./scripts/controllers/auth/landing-page.html
// module id = lFCP
// module chunks = 0